import api from './api';

import router from './router';
import saga from './saga';

export default (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
        ignoredActions: ['toast/displayToast'],
        ignoredActionPaths: ['payload.apiCall.actions', 'payload.actions', 'payload.error'],
        ignoredPaths: ['app.toast.message.$$typeof', 'app.toast.message.type']
    }
})
.concat(router)
.concat(saga)
.concat(api);
